import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import Slide from 'react-reveal/Slide';
import Box from 'common/src/components/Box';
import Text from 'common/src/components/Text';
import Heading from 'common/src/components/Heading';
import Button from 'common/src/components/Button';
import Image from 'common/src/components/Image';
import Container from 'common/src/components/UI/Container';

import {
  TimelineWrapper,
  TimelineItem,
  TimelineIndex,
  TimelineContent,
  TimelineDot,
  Hidden
} from './timeline.style';

import Illustration from 'common/src/assets/image/saas/illustration.png';

const StyledBox = styled(Box)`
  max-width: 100%;
  width: 100%;
  margin-bottom: 80px;
  @media screen and (min-width: 1220px) {
    max-width: 50%;
    margin-bottom: 0;
  }
`;

const TimelineSection = ({
  sectionWrapper,
  sectionHeader,
  sectionTitle,
  sectionSubTitle,
  row,
  col,
  button,
  textArea,
  imageArea,
  imageTwo,
  buttonWrapper,
  indexStyle,
  timelineTitle,
  timelineDescription
}) => {
  const Data = useStaticQuery(graphql`
    query {
      saasJson {
        Timeline {
          title
          description
        }
      }
    }
  `);

  return (
    <Box {...sectionWrapper} id="timeline_section">
      <Container>
        <Box {...sectionHeader}>
          <Text {...sectionSubTitle} content="Traditional v. LoanSense" />
          <Heading
            {...sectionTitle}
            content="How we help you launch a $400 - $800 student loan consultation service"
          />
        </Box>
        <Box {...row}>
          {/* <Box {...col} {...imageArea}>
            <Fade bottom>
              <Image {...imageTwo} src={Illustration} alt="Illustration" />
            </Fade>
          </Box> */}
          <StyledBox {...col} {...textArea}>
            <Heading
              as="h2"
              content="Traditional Way"
              {...timelineTitle}
              style={{ textAlign: 'center' }}
            />
            <TimelineWrapper>
              <TimelineItem
                key={`timeline-item`}
                small
                style={{ height: '140px' }}
              >
                <TimelineIndex small>
                  <Hidden>
                    <Slide bottom>
                      <Text
                        as="span"
                        content="New Client"
                        {...indexStyle}
                        style={{ color: '#311bd5' }}
                      />
                    </Slide>
                  </Hidden>
                </TimelineIndex>
                <TimelineContent>
                  <Hidden>
                    <Slide bottom delay={100}>
                      <Heading as="h2" content="" {...timelineTitle} />
                    </Slide>
                  </Hidden>
                  <Hidden>
                    <Slide bottom delay={200}>
                      <Text
                        content="Rely on referrals from current clients to grow my business. "
                        {...timelineDescription}
                      />
                      {/* <Text
                        content="Lost e-mail from servicer"
                        {...timelineDescription}
                      /> */}
                    </Slide>
                  </Hidden>
                </TimelineContent>
              </TimelineItem>
              <TimelineItem
                key={`timeline-item`}
                small
                style={{ height: '140px' }}
              >
                <TimelineIndex small>
                  <Hidden>
                    <Slide bottom>
                      <Text
                        as="span"
                        content="Client Service"
                        {...indexStyle}
                        style={{ color: '#311bd5' }}
                      />
                    </Slide>
                  </Hidden>
                </TimelineIndex>
                <TimelineContent>
                  <Hidden>
                    <Slide bottom delay={100}>
                      <Heading as="h2" content="" {...timelineTitle} />
                    </Slide>
                  </Hidden>
                  <Hidden>
                    <Slide bottom delay={200}>
                      <Text
                        content="Treat student debt like other debt and pay down ASAP.  "
                        {...timelineDescription}
                      />
                    </Slide>
                  </Hidden>
                </TimelineContent>
              </TimelineItem>
              <TimelineItem
                key={`timeline-item`}
                small
                style={{ height: '140px' }}
              >
                <TimelineIndex small>
                  <Hidden>
                    <Slide bottom>
                      <Text
                        as="span"
                        content="Client Retention"
                        {...indexStyle}
                        style={{ color: '#311bd5' }}
                      />
                    </Slide>
                  </Hidden>
                </TimelineIndex>
                <TimelineContent>
                  <Hidden>
                    <Slide bottom delay={100}>
                      <Heading as="h2" content="" {...timelineTitle} />
                    </Slide>
                  </Hidden>
                  <Hidden>
                    <Slide bottom delay={200}>
                      <Text
                        content="My clients will refer their children to me, who do not have student loans. "
                        {...timelineDescription}
                      />
                    </Slide>
                  </Hidden>
                </TimelineContent>
              </TimelineItem>
              {/* <TimelineItem key={`timeline-item`} small>
                <TimelineIndex small>
                  <Hidden>
                    <Slide bottom>
                      <Text
                        as="span"
                        content="Results"
                        {...indexStyle}
                        style={{ color: '#311bd5' }}
                      />
                    </Slide>
                  </Hidden>
                </TimelineIndex>
                <TimelineContent>
                  <Hidden>
                    <Slide bottom delay={100}>
                      <Heading as="h2" content="" {...timelineTitle} />
                    </Slide>
                  </Hidden>
                  <Hidden>
                    <Slide bottom delay={200}>
                      <Text
                        content="You lose $1000s in extra interest or unable to qualify for loan forgiveness."
                        {...timelineDescription}
                      />
                    </Slide>
                  </Hidden>
                </TimelineContent>
              </TimelineItem> */}
            </TimelineWrapper>
          </StyledBox>
          <StyledBox {...col} {...textArea}>
            <Heading
              as="h2"
              content="LoanSense Way"
              {...timelineTitle}
              style={{ textAlign: 'center' }}
            />
            <TimelineWrapper>
              <TimelineItem key={`timeline-item`} style={{ height: '140px' }}>
                <TimelineIndex>
                  <Hidden>
                    <Slide bottom>
                      <Text
                        as="span"
                        content="01"
                        {...indexStyle}
                        style={{ color: '#311bd5' }}
                      />
                    </Slide>
                  </Hidden>
                </TimelineIndex>
                <TimelineContent>
                  <Hidden>
                    <Slide bottom delay={100}>
                      <Heading as="h2" content="" {...timelineTitle} />
                    </Slide>
                  </Hidden>
                  <Hidden>
                    <Slide bottom delay={200}>
                      <Text
                        content="Utilize LoanSense’s marketing materials to <strong>position yourself as a student loan expert.</strong> Addressing the #1 financial concern of this generation makes you relevant."
                        {...timelineDescription}
                      />
                    </Slide>
                  </Hidden>
                </TimelineContent>
                <TimelineDot />
              </TimelineItem>
              <TimelineItem key={`timeline-item`} style={{ height: '140px' }}>
                <TimelineIndex>
                  <Hidden>
                    <Slide bottom>
                      <Text
                        as="span"
                        content="02"
                        {...indexStyle}
                        style={{ color: '#311bd5' }}
                      />
                    </Slide>
                  </Hidden>
                </TimelineIndex>
                <TimelineContent>
                  <Hidden>
                    <Slide bottom delay={100}>
                      <Heading as="h2" content="" {...timelineTitle} />
                    </Slide>
                  </Hidden>
                  <Hidden>
                    <Slide bottom delay={200}>
                      <Text
                        content="Take a <strong>holistic financial approach</strong> to help individuals find government money and consider options beyond refinance. <strong>LoanSense saves $1000s</strong>"
                        {...timelineDescription}
                      />
                    </Slide>
                  </Hidden>
                </TimelineContent>
                <TimelineDot />
              </TimelineItem>
              <TimelineItem key={`timeline-item`} style={{ height: '140px' }}>
                <TimelineIndex>
                  <Hidden>
                    <Slide bottom>
                      <Text
                        as="span"
                        content="03"
                        {...indexStyle}
                        style={{ color: '#311bd5' }}
                      />
                    </Slide>
                  </Hidden>
                </TimelineIndex>
                <TimelineContent>
                  <Hidden>
                    <Slide bottom delay={100}>
                      <Heading as="h2" content="" {...timelineTitle} />
                    </Slide>
                  </Hidden>
                  <Hidden>
                    <Slide bottom delay={200}>
                      <Text
                        content="<strong>Solve a serious financial problem when your client is in their 30s and retain a long-term customer.</strong>  
                        You manage your client's financial plan and relationship & we’ll handle the student loans."
                        {...timelineDescription}
                      />
                    </Slide>
                  </Hidden>
                </TimelineContent>
                <TimelineDot />
              </TimelineItem>
              {/* <TimelineItem key={`timeline-item`}>
                <TimelineIndex>
                  <Hidden>
                    <Slide bottom>
                      <Text
                        as="span"
                        content="04"
                        {...indexStyle}
                        style={{ color: '#311bd5' }}
                      />
                    </Slide>
                  </Hidden>
                </TimelineIndex>
                <TimelineContent>
                  <Hidden>
                    <Slide bottom delay={100}>
                      <Heading as="h2" content="" {...timelineTitle} />
                    </Slide>
                  </Hidden>
                  <Hidden>
                    <Slide bottom delay={200}>
                      <Text
                        content="LoanSense supports you so you are not alone. We saves you 30% to 50% off your entire loan balance. Make a plan today!"
                        {...timelineDescription}
                      />
                    </Slide>
                  </Hidden>
                </TimelineContent>
                <TimelineDot />
              </TimelineItem> */}
            </TimelineWrapper>
          </StyledBox>
        </Box>
        <Box {...buttonWrapper}>
          <a href="mailto:sales@myloansense.com">
            <Button {...button} title="Contact Sales" />
          </a>
        </Box>
      </Container>
    </Box>
  );
};

TimelineSection.propTypes = {
  sectionWrapper: PropTypes.object,
  sectionHeader: PropTypes.object,
  sectionTitle: PropTypes.object,
  sectionSubTitle: PropTypes.object,
  row: PropTypes.object,
  col: PropTypes.object,
  button: PropTypes.object,
  textArea: PropTypes.object,
  imageArea: PropTypes.object,
  imageTwo: PropTypes.object,
  buttonWrapper: PropTypes.object,
  indexStyle: PropTypes.object,
  timelineTitle: PropTypes.object,
  timelineDescription: PropTypes.object
};

TimelineSection.defaultProps = {
  sectionWrapper: {
    as: 'section',
    pt: ['60px', '80px', '80px', '80px'],
    pb: ['60px', '80px', '80px', '80px']
  }, // section header default style
  sectionHeader: {
    mb: '56px'
  },
  // sub section default style
  sectionSubTitle: {
    as: 'span',
    display: 'block',
    textAlign: 'center',
    fontSize: '14px',
    letterSpacing: '0.15em',
    fontWeight: '700',
    color: '#5268db',
    mb: '10px'
  },
  // section title default style
  sectionTitle: {
    textAlign: 'center',
    fontSize: ['20px', '24px'],
    fontWeight: '500',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: '0'
  },
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
    alignItems: 'center'
  },
  imageAreaRow: {
    flexDirection: 'row-reverse'
  },
  col: {
    pr: '15px',
    pl: '15px'
  },
  textArea: {
    width: ['100%', '100%', '55%', '50%', '55%'],
    mb: ['40px', '40px', '0', '0', '0']
  },
  imageArea: {
    width: ['100%', '100%', '45%', '50%', '45%'],
    mb: ['30px', '40px', '40px', '0', '0']
  },
  title: {
    fontSize: ['30px', '38px', '38px', '48px', '48px'],
    fontWeight: '300',
    color: 'headingColor',
    letterSpacing: '-0.025em',
    mb: '15px'
  },
  description: {
    fontSize: '16px',
    color: 'textColor',
    lineHeight: '1.75',
    mb: '33px'
  },
  buttonWrapper: {
    mt: ['25px', '50px'],
    flexBox: true,
    justifyContent: 'center'
  },
  button: {
    type: 'button',
    fontSize: '14px',
    fontWeight: '600',
    borderRadius: '4px',
    pl: '22px',
    pr: '22px',
    colors: 'primaryWithBg',
    height: '46px'
  },
  imageOne: {
    mb: '40px',
    ml: 'auto',
    mr: 'auto'
  },
  imageTwo: {
    ml: 'auto',
    mr: 'auto'
  },
  indexStyle: {
    fontSize: ['36px', '42px', '52px', '56px', '72px'],
    fontWeight: '300',
    color: '#eaebec',
    display: 'block',
    lineHeight: '1',
    mb: '0'
  },
  timelineTitle: {
    fontSize: ['16px', '17px', '18px', '18px', '20px'],
    fontWeight: '500',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: '13px'
  },
  timelineDescription: {
    fontSize: ['14px', '15px', '15px', '15px', '16px'],
    lineHeight: '2',
    color: '#5d646d',
    mb: '0'
  }
};

export default TimelineSection;
